import React from 'react';

type Props = {
  children?: React.ReactNode;
};

export default function DescirptionContainer({ children }: Props) {
  return (
    <div className="mt-5 border-t border-gray-200">
      <dl className="sm:divide-y sm:divide-gray-200">{children}</dl>
    </div>
  );
}
